:host {
  display: flex;
  justify-content: center;
  @include cms-base-font-100;
}

.container {
  text-align: center;
  font-style: italic;
  margin: var(--cms-spacing-075);
  padding: 0 var(--cms-spacing-050);
  font-size: var(--cms-font-size-150);
  color: var(--cms-theme-text-color);

  a {
    color: var(--cms-theme-text-color);
  }

  .image {
    background-color: var(--cms-quoteImageColor);
    width: 36px;
    height: 36px;
    display: inline-block;
    -webkit-mask-size: 36px;
    mask-size: 36px;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }
}